import React from 'react';
import IconBase from './IconBase';
import {default as OpenInNewIconMUI} from '@mui/icons-material/OpenInNew';

const OpenInNewIcon = props => {
    return (
        <IconBase {...props}>
            <OpenInNewIconMUI/>
        </IconBase>
    )
}

export default OpenInNewIcon;